import { ANALYTICS_HEAP_IDS, formatHeapId } from '@/common/constants';
import React from 'react';
import styles from './SocialMediaIcon.module.scss';

export interface SocialMediaIconProps {
  icon: string;
  link: string;
}

export const SocialMediaIcon: React.FC<SocialMediaIconProps> = ({ icon, link }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="nofollow noopener"
      data-heap-id={formatHeapId([ANALYTICS_HEAP_IDS.FOOTER_GENERAL, link])}
      className={styles.icon_link}
    >
      <div className={styles.icon}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={icon} alt={link} title={link} loading="lazy" decoding="async" />
      </div>
    </a>
  );
};
